import React, { useState } from 'react';
import { isMobile } from './utils/MobileUtils';

interface ReviewInterface {
    image: any;
    review: string;
    name: string;
}

function Reviews() {
    const leftArrowIcon = require("./images/orangeLeftArrow.png");
    const rightArrowIcon = require("./images/orangeRightArrow.png");

    const brianaImg = require("./images/reviews/Briana.PNG");
    const AudreyImg = require("./images/reviews/Audrey.JPG");
    const hasmikImg = require("./images/reviews/Hasmik.PNG");
    const annaImg = require("./images/reviews/Anna.JPG");
    const brookeImg = require("./images/reviews/Brooke.jpeg");
    const surenImg = require("./images/reviews/Suren.PNG");

    const defaultEndIdx = isMobile() ? 0 : 2;
    const [startIdx, setStartIdx] = useState(0);
    const [endIdx, setEndIdx] = useState(defaultEndIdx);
    const [fade, setFade] = useState(false);

    const allReviews: ReviewInterface[] = [
        { image: brianaImg, review: "Fun, well made party game to play with friends.", name: "BRIANA S."},
        { image: AudreyImg, review: "Such a fun game! Justly is a funny, easy to play game. Highly recommend!", name: "AUDREY B."},
        { image: hasmikImg, review: "This game exposes your friends in the funniest way possible. The cards are relatable. Every round someone says, 'Okay, this is so me' or 'I know someone like this'", name: "HASMIK M."},
        { image: annaImg, review: "My favorite part is that the funniest answer doesn't always come from the loudest person. Even friends who are usually quiet kept coming up with cards that had everyone crying from laughter.", name: "ANNA P."},
        { image: brookeImg, review: "I love playing justly bc it's a sure way to get everyone laughing and talking! The punishments are cleverly written and I love the range!", name: "BROOKE B."},
        { image: surenImg, review: "I haven't laughed this hard during a game night in years. Justly somehow gets everyone roasting each other in a fun and unique way!", name: "SUREN M."}
    ]

    const handleReviewsSectionButtonClick = (newStartIndex: number, newEndIndex: number) => {
        if (newStartIndex < 0) {
            return;
        }

        if (newEndIndex >= allReviews.length) {
            return;
        }

        setFade(true);

        setTimeout(() => {
            setStartIdx(newStartIndex);
            setEndIdx(newEndIndex);
            setFade(false);
        }, 100);
    }

    return (
        <div className="reviewsOuterWrapper">
            <div className="reviewsInnerWrapper">
                <div className="reviewsTitle">PLAYER FEEDBACK</div>
                <div className="reviewsSubtitle">REVIEWS</div>
                <div className={`reviewsSectionWrapper ${fade ? "reviews-fade-out" : "reviews-fade-in"}`}>
                    {allReviews.slice(startIdx, endIdx + 1).map((review, idx) => {
                        return <div className="reviewsSection" key={idx}>
                            <img className="reviewsSectionImage" src={review.image} alt="reviewer"/>
                            <div className="reviewsSectionReview">{review.review}</div>
                            <div className="reviewsSectionName">{review.name}</div>
                        </div>
                    })}
                    <div className="reviewsSectionLeftButtonWrapper" tabIndex={0} onClick={() => handleReviewsSectionButtonClick(startIdx - 1, endIdx - 1)} onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleReviewsSectionButtonClick(startIdx - 1, endIdx - 1);
                        }
                    }}>
                        <img className="reviewsSectionArrowIcon" src={leftArrowIcon} alt="up arrow"/>
                    </div>
                    <div className="reviewsSectionRightButtonWrapper" tabIndex={0} onClick={() => handleReviewsSectionButtonClick(startIdx + 1, endIdx + 1)} onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleReviewsSectionButtonClick(startIdx + 1, endIdx + 1);
                        }
                    }}>
                        <img className="reviewsSectionArrowIcon" src={rightArrowIcon} alt="up arrow"/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Reviews;